import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SectionComponent } from 'src/app/shared/components/section/section.component';
import { SubsectionComponent } from 'src/app/shared/components/subsection/subsection.component';

@Component({
  selector: 'app-tos',
  standalone: true,
  imports: [RouterModule, SectionComponent, SubsectionComponent],
  templateUrl: './tos.component.html',
  styleUrls: ['./tos.component.scss'],
})
export class TosComponent {}
